export default __webpack_public_path__ + "static/media/screenshot2_sm.b21f4ead.jpg";